export default "/assets/images/awards-img-02-sm.svg?adddcd35ae939e4ab3912bc95fe4bd83";